export const SET_DASHBOARD_CONTENT = 'SET_DASHBOARD_CONTENT';
export const SET_TOP_FIVE_BY_NOI = 'SET_TOP_FIVE_BY_NOI';
export const SET_TOP_FIVE_BY_COC = 'SET_TOP_FIVE_BY_COC';
export const SET_RECENT_PROPERTIES = 'SET_RECENT_PROPERTIES';
